import { FLASH_TIMEOUT } from '@/consts';

let activeTimeout;

const mutations = {
  setMessage(state, msg) {
    if (activeTimeout) clearTimeout(activeTimeout);
    state.message = msg;
  },

  setType(state, type) {
    state.type = type;
  },

  setActiveStatus(state, { value, autoHide }) {
    state.isActive = value;

    if (value) {
      if (activeTimeout) clearTimeout(activeTimeout);

      if (autoHide) {
        activeTimeout = setTimeout(() => {
          state.isActive = false;
        }, FLASH_TIMEOUT);
      }
    }
  }
};

export default mutations;
